import { render, staticRenderFns } from "./LogIcon.vue?vue&type=template&id=87f1e33a"
import script from "./LogIcon.vue?vue&type=script&lang=js"
export * from "./LogIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports